import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RestService } from "./rest.service";
import { Title } from "@angular/platform-browser";
import { GlobalElement } from "./global.elements";

@Injectable()
export class AuthorizatedGuard implements CanActivate {

  constructor(private titleService: Title, private router: Router, private restService: RestService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const permission = route.data.permission as string;
    GlobalElement.permission = permission;
    try {
      return this.restService.user_validate(permission)
        .map(data => {
          if (data.success) {
            this.titleService.setTitle("CLARA | " + permission);
            return true;
          } else {
            if (this.restService.getToken()) this.router.navigate(['/401']);
            else this.router.navigate(['/signin']);
            return false;
          }
        })
    } catch (error) {
      this.router.navigate(['/signin']);
      return false;
    }

  }
}